/**
 * SEO Sprint 2 (Feb 2026) — Standardised breadcrumb strip wrapper.
 *
 * Wraps <Breadcrumbs> in a narrow strip (white background, bottom
 * border) and a max-width container so it slots neatly between the
 * page banner and the page content. Used on:
 *   - FAQ
 *   - Documenten
 *   - BTW terugvragen
 *   - Paklijst, Boekingsformulier (via direct usage)
 *   - Service-pagina's & destination-pagina's (already inlined there)
 *
 * Renders nothing if `items` is empty.
 */
import React from "react";
import Breadcrumbs from "./Breadcrumbs";

export default function PageBreadcrumbs({ items, testid }) {
  if (!Array.isArray(items) || items.length === 0) return null;
  return (
    <div className="bg-white border-b border-gray-100" data-testid={testid ? `${testid}-strip` : undefined}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <Breadcrumbs items={items} testid={testid} />
      </div>
    </div>
  );
}
